import { render, staticRenderFns } from "./manageTemplate.vue?vue&type=template&id=22f7dd27&"
import script from "./manageTemplate.vue?vue&type=script&lang=js&"
export * from "./manageTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports